/* istanbul ignore file */
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useShowContext } from 'framework/show';
import { DEFAULT_ERROR_MESSAGE } from 'framework/form';
import { ErrorMessage, useMessageService } from 'framework/ui/Message';
import { FieldListLayout } from 'framework/ui/layout';
import { useArtifactDownloadHelper } from 'domain/shared/artifact';
import { TemplateDocumentStorageContext } from 'domain/shared/documentStorage';
import CandidateOfferCompensationDetailsField from 'domain/recruiting/candidate/offercompensation/Show/CandidateOfferCompensationDetailsField';

const OFFER_DOCUMENT_FILE_NAME = 'candidate_offer.pdf';

interface OfferCompensationDetailsSectionProps {
  canViewCalculatedGrossField: boolean;
}

const OfferCompensationDetailsSection = ({ canViewCalculatedGrossField }: OfferCompensationDetailsSectionProps) => {
  const { data: offerData } = useShowContext();
  const { downloadDocumentStorage } = useArtifactDownloadHelper();
  const { addMessage } = useMessageService();

  const offerDocumentPath = offerData?.offerDocumentPath;
  const hasCommittedOfferDocument = !!offerDocumentPath && !offerDocumentPath.startsWith('/temp/');

  const handleDownload = async () => {
    if (!offerDocumentPath) return;

    try {
      await downloadDocumentStorage(offerDocumentPath);
    } catch {
      addMessage(new ErrorMessage(DEFAULT_ERROR_MESSAGE));
    }
  };

  return (
    <Box display="flex" flexDirection="row">
      <FieldListLayout source="compensationDetails" sx={{ width: '100%' }}>
        <CandidateOfferCompensationDetailsField
          canViewCalculatedGrossField={canViewCalculatedGrossField}
          offerLinkField={
            hasCommittedOfferDocument ? (
              <TemplateDocumentStorageContext>
                <Button variant="text" sx={{ p: 0 }} onClick={handleDownload} title={offerDocumentPath}>
                  {OFFER_DOCUMENT_FILE_NAME}
                </Button>
              </TemplateDocumentStorageContext>
            ) : null
          }
        />
      </FieldListLayout>
    </Box>
  );
};

export default OfferCompensationDetailsSection;
